import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const useFormatElementData = (data) => {
  const patoType = data?.patoList?.map((el) => ({
    ItemValue: el.Id,
    ItemContent: ArabicToPersian(el.Name),
  }));

  const noeTaeed = [
    {
      ItemContent: FindLangKey(
        'lab-patient-type-confirm-not-confirmed'
      ),
      ItemValue: 0,
    },
    {
      ItemContent: FindLangKey(
        'lab-patient-type-confirm-confirmed'
      ),
      ItemValue: 1,
    },
    // {
    //   ItemContent: FindLangKey(
    //     'lab-patient-type-confirm-canceled'
    //   ),
    //   ItemValue: 2,
    // },
    {
      ItemContent: FindLangKey(
        'lab-patient-type-confirm-all'
      ),
      ItemValue: 3,
    },
  ];

  return [patoType, noeTaeed];
};

export default useFormatElementData;
